const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj || {}, key);

export const formatOrderDateRangeLabel = (fromValue, toValue) => {
  const formatDate = (value) => {
    if (!value) return '';
    const [year, month, day] = value.split('-');
    if (!year || !month || !day) return value;
    return `${day}/${month}/${year}`;
  };

  const fromText = formatDate(fromValue);
  const toText = formatDate(toValue);

  if (fromText && toText) return `Từ ${fromText} đến ${toText}`;
  if (fromText) return `Từ ${fromText}`;
  if (toText) return `Đến ${toText}`;
  return '';
};

export const hasActiveFilterValue = (filterKey) => {
  if (typeof document === 'undefined') return false;

  const filterIbs = document.querySelectorAll(`[data-filter="${filterKey}"]`);
  return Array.from(filterIbs).some((filterIb) => {
    const thTag = filterIb.closest('th, .th');
    const selectedTag = thTag?.querySelector('.item_selected');
    return Boolean(selectedTag?.innerText.trim());
  });
};

export const normalizeOrderAdminDateRangeParams = ({ params, formData = {}, filter, isFirstSearch = false }) => {
  const nextParams = { ...params };
  delete nextParams.dateRange;
  const hasDateRangeInForm = hasOwn(formData, 'dateFrom') || hasOwn(formData, 'dateTo');
  const hasDateRangeInFilter = hasOwn(filter, 'dateFrom') || hasOwn(filter, 'dateTo');
  const hasDateRangeValue = Boolean(nextParams.dateFrom || nextParams.dateTo);

  if (!hasDateRangeValue) {
    delete nextParams.dateFrom;
    delete nextParams.dateTo;
    return nextParams;
  }

  if (hasDateRangeInForm || hasDateRangeInFilter) {
    if (!nextParams.dateFrom && !nextParams.dateTo) {
      delete nextParams.dateFrom;
      delete nextParams.dateTo;
    }
    return nextParams;
  }

  if (isFirstSearch) return nextParams;

  if (!hasActiveFilterValue('dateRange')) {
    delete nextParams.dateFrom;
    delete nextParams.dateTo;
  }

  return nextParams;
};
